/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
 ******************************************************************************************************************** */
import { TemplateThreatStatement } from './threats';

export type ThreatFieldTypes = 'threat_source' | 'prerequisites' | 'threat_action' | 'threat_impact' | 'impacted_goal' | 'impacted_assets';

export const threatFieldTypeMapping: {
  [key in ThreatFieldTypes]: keyof TemplateThreatStatement;
} = {
  threat_source: 'threatSource',
  prerequisites: 'prerequisites',
  threat_action: 'threatAction',
  threat_impact: 'threatImpact',
  impacted_goal: 'impactedGoal',
  impacted_assets: 'impactedAssets',
};

